<template>
  <b-row style="margin-bottom:30px">
    <b-col md="12">
      <b-card
        :style="{ backgroundColor: coloreSfondo, color: coloreTesto, borderColor: coloreBordo }"
      >
        <div class="row">
          <!-- PRIMA COLONNA -->
          <div class="col-xl-6 col-lg-12">
            <!-- CIRCUITI PRIMARIO -->
            <div class="row simply-editor">
              <div class="col-xl-8 col-lg-12 simply-item-container">
                <el-checkbox
                  v-show="!isVapore"
                  v-model="fixedCircuits"
                  :disabled="typeOfPhe == 2"
                ></el-checkbox>
                {{ uniTranslation("PHE10053") }}
              </div>
              <div class="col-xl-4 col-lg-12 simply-item-container">
                <VueAutonumeric
                  v-model="numberOfCircuitsPrimarySide"
                  :disabled="!fixedCircuits || typeOfPhe == 2"
                  class="form-control auto-numeric"
                  :options="{
                    digitGroupSeparator: '',
                    decimalCharacter: ',',
                    decimalPlaces: '0',
                    decimalCharacterAlternative: '.',
                    currencySymbol: '\u00a0€',
                    currencySymbolPlacement: 's',
                    roundingMethod: 'U',
                    emptyInputBehavior: '1',
                    symbolWhenUnfocused: '',
                    selectOnFocus: 'false',
                    currencySymbol: '',
                    negativePositiveSignPlacement: 'p',
                    minimumValue: '1',
                    maximumValue: '5'
                  }"
                ></VueAutonumeric>
              </div>
            </div>
            <!-- PERDITE DI CARICO PRIMARIO -->
            <div class="row simply-editor">
              <div class="col-xl-4 col-lg-12 simply-item-container">
                <el-checkbox v-model="pressureDropFilter"></el-checkbox>
                {{ uniTranslation("PHE818") }}
              </div>
              <div class="col-xl-4 col-lg-12 simply-item-container">
                <el-slider v-model="pressureDropFilterPrimarySide" :step="sliderStep" />
              </div>
              <div class="col-xl-4 col-lg-12 simply-item-container">
                <VueAutonumeric
                  v-model="pressureDropFilterPrimarySide"
                  class="form-control auto-numeric"
                  :options="{
                    digitGroupSeparator: '',
                    decimalCharacter: ',',
                    decimalPlaces: '0',
                    decimalCharacterAlternative: '.',
                    currencySymbol: '\u00a0€',
                    currencySymbolPlacement: 's',
                    roundingMethod: 'U',
                    emptyInputBehavior: 'zero',
                    symbolWhenUnfocused: '',
                    selectOnFocus: 'false',
                    currencySymbol: '',
                    negativePositiveSignPlacement: 'p'
                  }"
                ></VueAutonumeric>
              </div>
            </div>
            <!-- FILTRO PREZZO -->
            <div class="row simply-editor">
              <div class="col-xl-4 col-lg-12 simply-item-container">
                <el-checkbox v-model="priceFilter"></el-checkbox> {{ uniTranslation("PHE10052") }} %
              </div>
              <div class="col-xl-4 col-lg-12 simply-item-container">
                <el-slider v-model="priceFilterValue" :step="sliderStep" />
              </div>
              <div class="col-xl-4 col-lg-12 simply-item-container">
                <VueAutonumeric
                  v-model="priceFilterValue"
                  class="form-control auto-numeric"
                  :options="{
                    digitGroupSeparator: '',
                    decimalCharacter: ',',
                    decimalPlaces: '0',
                    decimalCharacterAlternative: '.',
                    currencySymbol: '\u00a0€',
                    currencySymbolPlacement: 's',
                    roundingMethod: 'U',
                    emptyInputBehavior: 'zero',
                    symbolWhenUnfocused: '',
                    selectOnFocus: 'false',
                    currencySymbol: '',
                    negativePositiveSignPlacement: 'p'
                  }"
                ></VueAutonumeric>
              </div>
            </div>
          </div>
          <!-- SECONDA COLONNA -->
          <div class="col-xl-6 col-lg-12">
            <!-- CIRCUITI SECONDARIO -->
            <div v-if="showCircuitsSecondarySide" class="row simply-editor">
              <div class="col-xl-8 col-lg-12 simply-item-container">
                <el-checkbox
                  v-show="!isVapore"
                  v-model="circuitiDiversi"
                  :disabled="!fixedCircuits || typeOfPhe == 2"
                ></el-checkbox>
                {{ uniTranslation("PHE10053") }}
              </div>
              <div class="col-xl-4 col-lg-12 simply-item-container">
                <VueAutonumeric
                  v-model="numberOfCircuitsSecondarySide"
                  :disabled="!circuitiDiversi || !fixedCircuits || typeOfPhe == 2"
                  class="form-control auto-numeric"
                  :options="{
                    digitGroupSeparator: '',
                    decimalCharacter: ',',
                    decimalPlaces: '0',
                    decimalCharacterAlternative: '.',
                    currencySymbol: '\u00a0€',
                    currencySymbolPlacement: 's',
                    roundingMethod: 'U',
                    emptyInputBehavior: '1',
                    symbolWhenUnfocused: '',
                    selectOnFocus: 'false',
                    currencySymbol: '',
                    negativePositiveSignPlacement: 'p',
                    minimumValue: '1',
                    maximumValue: '5'
                  }"
                ></VueAutonumeric>
              </div>
            </div>
            <div v-else class="row simply-editor">
              <div class="col-xl-12 col-lg-12">&nbsp;</div>
            </div>
            <!-- PERDITE DI CARICO SECONDARIO -->
            <div class="row simply-editor">
              <div class="col-xl-4 col-lg-12 simply-item-container">
                <label>{{ uniTranslation("PHE818") }}</label>
              </div>
              <div class="col-xl-4 col-lg-12 simply-item-container">
                <el-slider v-model="pressureDropFilterSecondarySide" :step="sliderStep" />
              </div>
              <div class="col-xl-4 col-lg-12 simply-item-container">
                <VueAutonumeric
                  v-model="pressureDropFilterSecondarySide"
                  class="form-control auto-numeric"
                  :options="{
                    digitGroupSeparator: '',
                    decimalCharacter: ',',
                    decimalPlaces: '0',
                    decimalCharacterAlternative: '.',
                    currencySymbol: '\u00a0€',
                    currencySymbolPlacement: 's',
                    roundingMethod: 'U',
                    emptyInputBehavior: 'zero',
                    symbolWhenUnfocused: '',
                    selectOnFocus: 'false',
                    currencySymbol: '',
                    negativePositiveSignPlacement: 'p'
                  }"
                ></VueAutonumeric>
              </div>
            </div>
            <!-- FILTRO POTENZA -->
            <div class="row simply-editor">
              <div class="col-xl-4 col-lg-12 simply-item-container">
                <label>{{ uniTranslation("PHE600") }} %</label>
              </div>
              <div class="col-xl-4 col-lg-12 simply-item-container">
                <el-slider v-model="capacityFilterValue" :step="sliderStep" />
              </div>
              <div class="col-xl-4 col-lg-12 simply-item-container">
                <VueAutonumeric
                  v-model="capacityFilterValue"
                  class="form-control auto-numeric"
                  :options="{
                    digitGroupSeparator: '',
                    decimalCharacter: ',',
                    decimalPlaces: '0',
                    decimalCharacterAlternative: '.',
                    currencySymbol: '\u00a0€',
                    currencySymbolPlacement: 's',
                    roundingMethod: 'U',
                    emptyInputBehavior: 'zero',
                    symbolWhenUnfocused: '',
                    selectOnFocus: 'false',
                    currencySymbol: '',
                    negativePositiveSignPlacement: 'p'
                  }"
                ></VueAutonumeric>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import VueAutonumeric from "../shared/VueAutonumeric";
import { Slider, Checkbox } from "element-ui";
import { mapGetters } from "vuex";
import jsonHelper from "../../shared/jsonHelper";
import colorsService from "../../services/backend/colorsService";

export default {
  components: {
    VueAutonumeric,
    "el-slider": Slider,
    "el-checkbox": Checkbox
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      calculationType: "",
      coloreSfondo: "",
      coloreTesto: "",
      coloreBordo: "",
      numberOfCircuitsPrimarySide: 1,
      numberOfCircuitsSecondarySide: 1,
      fixedCircuits: true,
      circuitiDiversi: false,
      showCircuitsSecondarySide: false,
      connessioni: true,
      pressureDropFilterPrimarySide: 0,
      pressureDropFilterSecondarySide: 0,
      pressureDropFilter: true,
      priceFilterValue: 0,
      priceFilter: false,
      capacityFilterValue: 0,
      capacityFilter: true,
      sliderStep: 5,
      typeOfPhe: 0,
      isVapore: false
    };
  },
  computed: {
    ...mapGetters(["projects"])
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    },
    tollPos: function(newval /*, oldval*/) {
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".capacityTolerancePositive",
        value: newval
      });
    },
    tollNeg: function(newval /*, oldval*/) {
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".capacityToleranceNegative",
        value: newval
      });
    },
    connessioni: function(newval /*, oldval*/) {
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".connections",
        value: newval
      });
    },
    pressureDropFilterPrimarySide: function(newval /*, oldval*/) {
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".pressureDropTolerancePositive",
        value: newval
      });
    },
    pressureDropFilterSecondarySide: function(newval /*, oldval*/) {
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".pressureDropToleranceNegative",
        value: newval
      });
    },
    capacityFilter: function(newval /*, oldval*/) {
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".capacityFilter",
        value: newval
      });
    },
    capacityFilterValue: function(newval /*, oldval*/) {
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".capacityFilterValue",
        value: newval
      });
    },
    priceFilter: function(newval /*, oldval*/) {
      //alert(newval);
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".priceFilter",
        value: newval
      });
    },
    priceFilterValue: function(newval /*, oldval*/) {
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".priceFilterValue",
        value: newval
      });
    },
    pressureDropFilter: function(newval /*, oldval test*/) {
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".pressureDropFilter",
        value: newval
      });
    },
    fixedCircuits: function(newval /*, oldval*/) {
      if (!newval) {
        this.numberOfCircuitsSecondarySide = this.numberOfCircuitsPrimarySide;
      }
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".fixedCircuits",
        value: newval
      });
    },
    circuitiDiversi: function(newval /*, oldval*/) {
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".soloCircuitiUguali",
        value: !newval
      });
    },
    numberOfCircuitsPrimarySide: function(newval /*, oldval*/) {
      newval = Math.max(Math.min(parseInt(newval), 5), 0);
      if (!this.circuitiDiversi) {
        this.numberOfCircuitsSecondarySide = this.numberOfCircuitsPrimarySide;
      }
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".numberOfCircuitsPrimarySide.input.usrValue.value",
        value: newval
      });
    },
    numberOfCircuitsSecondarySide: function(newval /*, oldval*/) {
      newval = Math.max(Math.min(parseInt(newval), 5), 0);
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".numberOfCircuitsSecondarySide.input.usrValue.value",
        value: newval
      });
    },
    typeOfPhe: function(newval) {
      if (newval == 2) {
        this.numberOfCircuitsPrimarySide = 1;
        this.numberOfCircuitsSecondarySide = 1;
        this.fixedCircuits = true;
        this.circuitiDiversi = false;
      }
    }
  },
  created: function() {
    if (this.parentPath && this.localPath) {
      this.path = this.parentPath + this.localPath;
    }
  },
  mounted: function() {
    var that = this;
    //colorsService.getColoriCard().then(function(data) {
    var colorList = colorsService.getColoriCard();
    that.coloreSfondo = colorList[0] + " !important";
    that.coloreTesto = colorList[2];
    that.coloreBordo = colorList[6];
    //});
    this.tollPos = jsonHelper.getProperty(this.projects, this.path + ".capacityTolerancePositive");
    this.tollNeg = jsonHelper.getProperty(this.projects, this.path + ".capacityToleranceNegative");
    this.connessioni = jsonHelper.getProperty(this.projects, this.path + ".connections");

    var m = jsonHelper.getProperty(this.projects, this.parentPath + ".modality");
    if (m == 11) {
      this.isVapore = true;
    } else {
      this.isVapore = false;
    }

    console.log(this.isVapore);

    this.showCircuitsSecondarySide = this.$store.getters.profiloUtente.circuitFree;

    const c1 = jsonHelper.getProperty(
      this.projects,
      this.path + ".numberOfCircuitsPrimarySide.input.usrValue.value"
    );

    const c2 = jsonHelper.getProperty(
      this.projects,
      this.path + ".numberOfCircuitsSecondarySide.input.usrValue.value"
    );

    this.numberOfCircuitsPrimarySide = Math.max(Math.min(c1, 5), 1);
    this.numberOfCircuitsSecondarySide = Math.max(Math.min(c2, 5), 1);

    this.fixedCircuits = jsonHelper.getProperty(this.projects, this.path + ".fixedCircuits");
    console.log("fixedCircuits >>>> " + this.fixedCircuits);
    this.circuitiDiversi = !jsonHelper.getProperty(
      this.projects,
      this.path + ".soloCircuitiUguali"
    );
    console.log("circuitiDiversi >>>> " + this.circuitiDiversi);

    this.pressureDropFilterPrimarySide = jsonHelper.getProperty(
      this.projects,
      this.path + ".pressureDropTolerancePositive"
    );
    this.pressureDropFilterSecondarySide = jsonHelper.getProperty(
      this.projects,
      this.path + ".pressureDropToleranceNegative"
    );
    this.capacityFilter = jsonHelper.getProperty(this.projects, this.path + ".capacityFilter");
    this.pressureDropFilter = jsonHelper.getProperty(
      this.projects,
      this.path + ".pressureDropFilter"
    );
    that.$store.subscribe(function(mutation /*, state*/) {
      if (mutation.type === "changeTypeOfPhe") {
        that.typeOfPhe = mutation.payload;
      }
    });
  }
};
</script>

<style lang="scss">
$input-height: 30px;
.no-border-bottom {
  div {
    .el-collapse-item__header {
      border-bottom: none;
    }
  }
}
.simply-editor {
  background-color: transparent;
  margin: 0 0 0px 0px !important;
  padding: 5px 0;
  //width: 100%;
  outline: none;

  .simply-item-container {
    border: none;
    height: $input-height !important;
    padding: 0 5px;

    /* .select {
      border: none;
    } */

    .form-control {
      //padding: 0px;
      border-radius: 5px;
      height: $input-height !important;

      &.el-select {
        .el-input {
          .el-input__inner {
            height: $input-height !important;
            //padding: 0px 25px 0px 5px;
          }
        }
      }
    }

    .form-control:focus {
      box-shadow: none;
    }

    .form-control:disabled {
      background-color: #e8e8e8;
    }
  }
}
/*
.label-unidato {
  margin-top: 9px;
  margin-bottom: 0px;
}
.loading {
  opacity: 0.3;
}
*/
</style>
